import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import FormLabel from '@material-ui/core/FormLabel';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import Grid from '../../../components/layout/Grid';
import { withTranslation, Trans } from 'react-i18next'
import {getUser} from "../../../utils/sessions";
import Modal from '../../../components/modal/Modal';
import ListingAutoComplete from "../../../components/form/ListingAutoComplete";
import UploadField from "../../../components/form/UploadField";
import FormHelperText from "@material-ui/core/FormHelperText";

class ClaimListingModal extends Component {
    state = {
        proofDoc: null,
        listing: null,
        categoriesLoaded: false,
    };

    render() {
        const { open, onClose } = this.props;
        return (
            <Modal open={open} title="Claim a Listing">
                <Grid container spacing={3}>
                    <Grid item>
                        <Mutation mutation={listingClaimMutation} onCompleted={this.onCompleted}>
                            {this.renderForm}
                        </Mutation>
                    </Grid>
                </Grid>
            </Modal>
        );
    }

    getFileExtension(filename){
        const extension = filename.split('.').pop();
        return extension;
    }

    getBaseName(filename)
    {
        const name = filename.split('/').pop();
        return name;
    }

    renderForm = (mutate, results = {}) => {
        const { loading } = results;
        const { planID, onClose } = this.props;

        const { proofDoc, listing } = this.state;
        const error = '';
        const extension = proofDoc ? this.getFileExtension(proofDoc.filename) : null;
        let iconURL = '';
        let baseName = proofDoc ? this.getBaseName(proofDoc.filename) : null;
        let fileTypes = ['pdf', 'doc', 'docx'];
        if (proofDoc) {
            if (fileTypes.indexOf(extension) >= 0) {
                iconURL = 'images/icons/' + extension + '.png';
            } else {
                iconURL = proofDoc.url;
            }
        }


        const onSubmit = e => {
            if (e) e.preventDefault();
            if (loading) return;

            mutate({
                variables: {
                    listingID: listing.ID,
                    proofDocID: proofDoc.id,
                    memberID: getUser().ID
                }
            });
        };

        return (
            <form
                className="claim-form"
                onSubmit={onSubmit}
                ref="form"
            >
                <div className='field-holder'>
                    <FormLabel>
                        <Trans i18nKey="myListings.claimListing.title">
                            Listing
                        </Trans>
                    </FormLabel>
                    <ListingAutoComplete
                        selectProps={{ multiple: false }}
                        placeholder="Search for your listing..."
                        onSelect={(_, listing) => this.handleSelectListing(listing)}
                        variant="outlined"
                        value={listing ? listing.Title : ''}
                        includeEvents={true}
                    />
                    <FormHelperText>
                        <Trans i18nKey="myListings.claimListing.selectFromList">
                            Select listing from the options. If your listing is not here, please submit one.
                        </Trans>
                    </FormHelperText>
                </div>
                <div className='field-holder'>
                    <FormLabel>
                        <Trans i18nKey="myListings.claimListing.proof">
                            Proof Document
                        </Trans>
                    </FormLabel>
                    <UploadField
                        folderPath='ListingImages/Portal/ClaimDocs/'
                        onComplete={({ uploadFile }) => this.setState({ proofDoc: uploadFile})}
                    />
                    {!!proofDoc && (
                        <div className="uploaded-image-details">
                            <div className="uploaded-image-detail">
                                <div className={'uploaded-image-detail__icon'}>
                                    <img src={iconURL}/>
                                </div>
                                <div className={'uploaded-image-detail__details'}>
                                    <a href={proofDoc.url} target={'_blank'}>
                                        {baseName}
                                    </a>
                                </div>

                                <Button
                                    title="Remove image"
                                    variant="link-red"
                                    onClick={(e) => this.setState({ proofDoc: null })}
                                >
                                    Remove
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
                <div className='action-buttons'>
                    <div className='button-flex'>
                        <Button variant="outlined" onClick={e => onClose()}>
                            <Trans i18nKey="buttonCancel">
                                Cancel
                            </Trans>
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            className="button-base primary"
                            disabled={!listing || !proofDoc || loading}
                        >
                            <Trans i18nKey="myListings.claimListing.button">
                                Claim
                            </Trans>
                        </Button>
                    </div>
                </div>
            </form>
        );
    };

    handleSelectListing(listing) {
        if (listing) {
            this.setState({ listing: listing });
        }
    }

    onCompleted = data => {
        const claim = (data && data.createClaimListingRequest);
        if (!claim) return;

        const { onClaimed, onClose } = this.props;
        if (onClaimed) {
            onClaimed();
        }

        this.setState({
            listing: null,
            proofDoc: null,
        });

        if (onClose) {
            onClose();
        }
    };

}

export const listingClaimMutation = gql`
    mutation ClaimListing($listingID: ID!, $memberID: ID!, $proofDocID: ID!) {
        createClaimListingRequest(ListingID: $listingID, MemberID: $memberID, ProofDocID: $proofDocID) {
            ID
        }
    }
`;

export default withTranslation()(ClaimListingModal);